import { render, staticRenderFns } from "./negotiatePricesDialog.vue?vue&type=template&id=b2146a9e&scoped=true"
import script from "./negotiatePricesDialog.vue?vue&type=script&lang=js"
export * from "./negotiatePricesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2146a9e",
  null
  
)

export default component.exports